import { defineComponent } from '@digitalbranch/app'

import { uiBaseButton } from '../base-button/base-button'
import { uiRipple } from '../../ripple/ripple'

import template from './button.html'
import css from './button.css'


export const uiButton = defineComponent({
  name: 'ui-button',
  props: ['type', { name: 'disabled', type: 'boolean' }, { name: 'variant', type: 'string', default: 'filled' }],
  components: {
    uiRipple,
    uiBaseButton
  },
  template,
  css,
  formAssociated: true,
  delegatesFocus: false,
  listeners: {
    ready() {
      this.$node.setAttribute('tabindex', '0')
      this.$node.setAttribute('role', this.to || this.href ? 'link' : 'button')

      this.$addEventListener(this.$node, 'focus', this.handleFocus.bind(this))
    },
    beforeDestroy() {
      this.$node.removeEventListener('focus', this.boundHandleFocus)
    },
  },
  methods: {
    handleFocus() {
      this.$refs.button.focus()
    },
  },
  computed: {
    buttonClasses() {
      return [
        `ui-icon-button--variant-${this.variant}`,
        this.disabled && 'ui-icon-button--is-disabled'
      ]
    },
  },
})
